import React from 'react';
import { Text, View, Image } from '@react-pdf/renderer';
import { GENERAL_SETTLEMENT } from 'src/Utils/constants';
import { LogoPdf } from 'src/assets/Images';
import styles from './styles';
export var PDFHeader = function () { return (React.createElement(View, { style: styles.header },
    React.createElement(Text, null, GENERAL_SETTLEMENT),
    React.createElement(Image, { src: LogoPdf, style: styles.logo }))); };
